    export class RequestPassword{
        clientNumber!: Number;
        userId!: Number;
        oldPassword!: string;
        password!: string;
        newPassword!: string;

    }